/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_StorefrontInputs */

const en_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Storefront`)
};

const es_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir tienda`)
};

const fr_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager la vitrine`)
};

const de_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront teilen`)
};

const ja_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントを共有`)
};

const zh_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享店铺`)
};

const ar_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاركة واجهة المتجر`)
};

const id_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan Etalase`)
};

const it_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi Vetrina`)
};

const ru_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделиться витриной`)
};

const pt_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar Vitrine`)
};

const ko_share_storefront = /** @type {(inputs: Share_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 공유`)
};

/**
* | output |
* | --- |
* | "Share Storefront" |
*
* @param {Share_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const share_storefront = /** @type {((inputs?: Share_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_storefront(inputs)
	if (locale === "es") return es_share_storefront(inputs)
	if (locale === "fr") return fr_share_storefront(inputs)
	if (locale === "de") return de_share_storefront(inputs)
	if (locale === "ja") return ja_share_storefront(inputs)
	if (locale === "zh") return zh_share_storefront(inputs)
	if (locale === "ar") return ar_share_storefront(inputs)
	if (locale === "id") return id_share_storefront(inputs)
	if (locale === "it") return it_share_storefront(inputs)
	if (locale === "ru") return ru_share_storefront(inputs)
	if (locale === "pt") return pt_share_storefront(inputs)
	return ko_share_storefront(inputs)
});